export const _mapValueToPixel = v => v + 'px';
export const setStyles = (dom, styles, _map = v => v) => 
  Object.keys(styles).forEach((prop) => dom.style[prop] = _map(styles[prop]));
export const Pluralize = (value, singular, plural) => value > 1 ? plural : singular;
export const round = (value, decimals) => {
  value *= 10 ** decimals;
  value = Math.round(value);
  value /= 10 ** decimals;
  return value;
};  
export const getUrlReferrer = (url, referrer) => {
  // return url + '?redirect_to=' + referrer;
  return `${url}?redirect_to=${encodeURIComponent(referrer)}`
}
export const stringContainsEmail = s => /^\S+@\S+\.\S+$/.test(s);
export const getSameOrigin = url => {
  const regexp = new RegExp(`^${window.location.origin}`, 'i');
  return regexp.test(url) === true;
};

export const responseHasErrors = (response) => {
  return (
    response.data.error || 
    response.data?.result === 'failure' || 
    response?.request?.status !== 200 || 
    response?.status !== 200
  );
};

/**
 * Gets the url params joined by `&`
 * @param {URLParam} params 
 * @returns {string} url params
 */
const buildRequestByParams = (params) => {
  return '?' + Object.keys(params).reduce((prev, param) => {
    prev.push(`${param}=${params[param]}`);
    return prev;
  }, []).join('&').toString();
}

/**
 * replace the current window 
 * @param {ReplaceState} options 
 */
export const windowReplaceState = ({
  params = null,
  append = '', 
  state = null, 
  title = document.title 
}) => {
  const {origin, pathname} = window.location;
  let requestUrl = (
    params !== null 
      ? buildRequestByParams(params)
      : append
  );

  const url = origin + pathname + requestUrl;
  
  /** 
   * push o replace da decidere in base al comportamento utente che si vuole prevedere
   */
  window.history.replaceState(state, title, url);
}

export const getUrlParam = (param, value) => {
  const urlParams = new URLSearchParams(window.location.search);
  const p = urlParams.get(param);
  return p ? (p.trim() === value) : false;
}

export const getUrlHasParam = (param) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

/**
 * Assign object B to object A
 * @param {object} a Object A
 * @param {object} b Object B
 * @returns {object}
 */
export const assign = (a, b) => {
  for (const key in b) {
    if (Object.hasOwnProperty.call(b, key)) {
      a[key] = b[key];
    }
  }
  return a;
}

/**
 * get formatted bites from a number
 * @param {number} a Number to check
 * @returns {NiceBytes}
 */
export const niceBytes = (a) => {
  let b = 0, c = parseInt(a,10) || 0;
  // iterate
  for(;1024<=c&&++b;) c/=1024;
  let r = c.toFixed(10>c&&0<b?1:0);
  let u = ["bytes","KB","MB","GB","TB","PB","EB","ZB","YB"][b];
  return { n: Number(r), u: u, pretty: r + ' ' + u };
};

/**
 * Performs a linear interpolation between two values
 * @param {number} a Start value
 * @param {number} b End value
 * @param {number} alpha interpolation
 * @returns {number} interpolated value
 */
export const lerp = (a, b, alpha) => a + alpha * (b - a);

/**
 * Determine if a given value is of type numerical
 * @param {unknown} value The value to check
 * @returns {boolean} value is numerical
 */
export const isNumerical = value => null !== String(value).match(/^\d+(\.\d+)?$/);

/**
 * Determine if a given value rapresents a number
 * @param {unknown} value The value to check
 * @returns {boolean} value is a number
 */
export const isNumfast = value => typeof value === "number";

/**
 * Determine if a given value rapresents a string
 * @param {unknown} value The value to check
 * @returns {boolean} value is a string
 */
export const isString = value => typeof value === "string";

/**
 * Determine if a value is of type boolean
 * @param {(string|boolean)} val Value to check
 * @returns {boolean} val
 */
export const getBool = val => {
  return isString(val) ? ["true", "1"].includes(val.toLowerCase()) : val;
}

export const xDebugScreenPoint = (left = 0, top = 0) => {
  const div = document.createElement('div');
  div.classList.add('x-debug-point');
  div.style.cssText = `
    position: fixed;
    top: ${top}px;
    left: ${left}px;
    width: ${left === 0 ? '100vw' : '2px'};
    height: ${top === 0 ? '100vh' : '2px'};
    background: red;
    z-index: 287246723;
  `;
  document.body.appendChild(div);
};

xDebugScreenPoint.clear = () => {
  let p = document.querySelector('.x-debug-point');
  if(p) p.parentElement.removeChild(p);
  return xDebugScreenPoint;
}
export const getDataset = (htmlElement, id) => {
  const closestElement = htmlElement.closest(`[data-${id}]`);
  if (closestElement) {
    return closestElement.dataset[id];
  }

  let sibling = htmlElement.previousElementSibling;
  while (sibling) {
    if (sibling.dataset[id]) {
      return sibling.dataset[id];
    }
    sibling = sibling.previousElementSibling;
  }

  sibling = htmlElement.nextElementSibling;
  while (sibling) {
    if (sibling.dataset[id]) {
      return sibling.dataset[id];
    }
    sibling = sibling.nextElementSibling;
  }

  return undefined;
};
export const selectContent = htmlElement => {
  const range = document.createRange();
  range.selectNodeContents(htmlElement);
  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
};

/**
 * Uppercase first char in string
 * @param {string} str String to transform
 * @returns {string} Transformed string
 */
export const ucFirst = str => String(str).charAt(0).toUpperCase() + String(str).slice(1);

/**
 * strstr - kyndof PHP equivalent strstr
 * @param {string} str The sting to translate
 * @param {StrStrTemplate} tpl the translation template
 * @returns {string} translated string
 */
export const strtr = (str, tpl) => {
  Object.keys(tpl).forEach((key) => str = String(str).replaceAll(key, tpl[key]));
  return str;
};

/**
 * Determine if a given image is dark or not.
 * @param {string} imageSrc The src image to check
 * @param {function} callback 
 *        The callback executed after function determined
 *        if image is dark or not. A boolean value is
 *        provided as an argument to the callback.
 */
export function isItDark(imageSrc, callback) {
  var fuzzy = 0.1;
  var img = document.createElement("img");
  img.src = imageSrc;
  img.style.display = "none";
  document.body.appendChild(img);
  
  img.onload = function() {
      // create canvas
      var canvas = document.createElement("canvas");
      canvas.width = this.width;
      canvas.height = this.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(this,0,0);

      var imageData = ctx.getImageData(0,0,canvas.width,canvas.height);
      var data = imageData.data;
      var r,g,b, max_rgb;
      var light = 0, dark = 0;

      for(var x = 0, len = data.length; x < len; x+=4) {
          r = data[x];
          g = data[x+1];
          b = data[x+2];

          max_rgb = Math.max(Math.max(r, g), b);
          if (max_rgb < 128)
              dark++;
          else
              light++;
      }

      var dl_diff = ((light - dark) / (this.width*this.height));
      if (dl_diff + fuzzy < 0)
          callback(true); /* Dark. */
      else
          callback(false);  /* Not dark. */
  }
}
/**
 * canvasToBlob
 * @param {CanvasRenderingContext2D} ctx canvas context
 * @returns {void}
 */
export const canvasToBlob = async (ctx, imageMimeType = 'image/jpg') => new Promise((resolve) => ctx.canvas.toBlob(resolve, imageMimeType));

/**
 * canvasToBlob
 * @param {CanvasRenderingContext2D} ctx canvas context
 * @returns {void}
 */
export const canvasToDataURL = async (ctx, imageMimeType = 'image/jpg') => new Promise((resolve) => resolve(ctx.canvas.toDataURL(imageMimeType)));

/**
 * drawOnContext
 * @param {CanvasRenderingContext2D} ctx context
 * @param {HTMLImageElement} image image
 * @returns {CanvasRenderingContext2D} context
 */
export const drawOnContext = (ctx, image) => {
  ctx.canvas.width = ctx.width = image.naturalWidth;
  ctx.canvas.height = ctx.height = image.naturalHeight;
  ctx.drawImage(image, 0, 0);
  return ctx;
}; 


export const breakpointSize = {
  xs: 400, // for small screen mobile
  sm: 640, // for mobile screen
  md: 770, // for tablets
  lg: 1024, // for laptops
  xl: 1440, // for desktop / monitors
  xxl: 1920, // for big screens
};

export const breakpoints = {
  xs: `(min-width: ${breakpointSize.xs}px)`,
  sm: `(min-width: ${breakpointSize.sm}px)`,
  md: `(min-width: ${breakpointSize.md}px)`,
  lg: `(min-width: ${breakpointSize.lg}px)`,
  xl: `(min-width: ${breakpointSize.xl}px)`,
  xxl: `(min-width: ${breakpointSize.xxl})`,
  down: key => `(max-width: ${breakpointSize[key]}px)`,
  up: key => `(min-width: ${breakpointSize[key] + 1}px)`,
  _down: key => window.innerWidth <= breakpointSize[key],
  _up: key => window.innerWidth > breakpointSize[key],
};

export const isScreen = (value) => {
  return breakpoints._down(value)
}

export function objectCompare(obj1, obj2) {
  // Verifica se gli oggetti sono la stessa referenza
  if (obj1 === obj2) {
    return []; // Gli oggetti sono uguali, non ci sono chiavi cambiate
  }

  // Se uno dei due oggetti è null o undefined, sono diversi
  if (obj1 == null || obj2 == null) {
    return Object.keys(obj1 || obj2); // Se uno è null, tutte le chiavi dell'altro sono cambiate
  }

  // Ottieni le chiavi di entrambi gli oggetti
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  const changedKeys = [];

  // Verifica se ci sono differenze nelle chiavi
  for (let key of keys1) {
    // Se la chiave è presente in obj2 e i valori sono diversi, aggiungi la chiave alla lista
    if (!keys2.includes(key) || obj1[key] !== obj2[key]) {
      changedKeys.push(key);
    }
  }

  // Controlla se ci sono chiavi in obj2 che non sono in obj1
  for (let key of keys2) {
    if (!keys1.includes(key)) {
      changedKeys.push(key);
    }
  }

  return changedKeys; // Restituisce l'elenco delle chiavi cambiate
}

